import type { LeadStatus } from '../types';
import { formatPhone } from '../utils/date';

interface PhoneNumberProps {
  phone: string;
  status: LeadStatus;
  showIcon?: boolean;
}

export function PhoneNumber({ phone, status, showIcon = true }: PhoneNumberProps) {
  const isBlurred = status !== 'qualified';

  return (
    <div 
      className="inline-flex items-center group relative"
      title={isBlurred ? 'Qualify lead to view phone number' : undefined}
    >
      {showIcon && isBlurred && (
        <svg 
          className="w-3.5 h-3.5 mr-1.5 text-gray-400 flex-shrink-0" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
          />
        </svg>
      )}
      <span 
        className={`${isBlurred ? 'blur-sm select-none' : ''} transition-all duration-200`}
        style={isBlurred ? { filter: 'blur(4px)', userSelect: 'none' } : undefined}
      >
        {formatPhone(phone)}
      </span>
      
      {/* Tooltip */}
      {isBlurred && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
          Qualify lead to view phone number
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
        </div>
      )}
    </div>
  );
}
